import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './CountdownTimer';
import { SocialProofPopup } from './SocialProofPopup';
import { CTAButton } from './CTAButton';
import { CheckCircle2, XCircle, Lock, ShieldCheck, ChevronRight } from 'lucide-react';
const PURCHASE_LINK = 'https://pagos.fegion.online/cart/45866696441995:1';
export function SalesPage() {
  useEffect(() => {
    // Force scroll to top on page load
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    // Also handle hash-based navigation prevention on initial load
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname);
    }
  }, []);
  useEffect(() => {
    // Initialize Meta Pixel directly via script injection
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '904978025482552');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-purple-200" data-id="element-7">
      <CountdownTimer data-id="element-8" />
      <SocialProofPopup data-id="element-9" />

      {/* SECTION 2 - HERO */}
      <section className="pt-12 pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-10">
        <div className="inline-block bg-purple-100 border border-purple-200 rounded-full px-6 py-2 mb-8" data-id="element-11">
          <p className="text-purple-800 font-semibold text-sm md:text-base" data-id="element-12">
            🟣 Para personas que sienten que el celular controla su tiempo, su
            atención y su energía… y quieren recuperar el control de su mente.
          </p>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-gray-900 tracking-tight mb-4 uppercase text-center" data-id="element-13">
          <span className="block" data-id="element-14">🧠 MEGA PACK</span>
          <span className="block text-purple-500" data-id="element-15">RESET DE DOPAMINA</span>
        </h1>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-600 mb-8" data-id="element-16">
          Sistema práctico para romper la adicción al celular y recuperar tu
          concentración en 14 días
        </h2>

        <a href="#compra" className="block cursor-pointer hover:opacity-95 transition-opacity mb-10" data-id="element-17">
          <img src="https://cdn.magicpatterns.com/uploads/rzEnN65CyTDuQo6YYdzGax/mockup_page-0001.jpg" alt="Mega Pack Reset de Dopamina" className="w-full max-w-3xl mx-auto rounded-xl shadow-2xl" data-id="element-18" />
        </a>

        <div className="max-w-3xl mx-auto text-lg md:text-xl text-gray-700 space-y-4 mb-10 font-medium" data-id="element-19">
          <p data-id="element-20">Si sentís que el celular te roba horas todos los días…</p>
          <p data-id="element-21">Si abrís redes sociales sin darte cuenta…</p>
          <p data-id="element-22">
            Si empezás revisando un mensaje y terminás viendo videos durante 40
            minutos…
          </p>
          <p className="font-bold text-red-600 text-xl md:text-2xl mt-6" data-id="element-23">
            El problema no es falta de disciplina.
          </p>
          <p className="mt-4" data-id="element-24">
            <span style={{
            color: '#8B5CF6'
          }} className="font-bold" data-id="element-25">
              El problema es dopamina digital.
            </span>
          </p>
        </div>

        <CTAButton text="👉 SÍ, QUIERO EMPEZAR MI RESET AHORA" data-id="element-26" />

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mt-6 font-semibold text-gray-700" data-id="element-27">
          <span className="flex items-center gap-2" data-id="element-28">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-29" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-2" data-id="element-30">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-31" /> Resultados en 14
            días
          </span>
          <span className="flex items-center gap-2" data-id="element-32">
            <CheckCircle2 className="text-green-500 w-5 h-5" data-id="element-33" /> Sistema paso a
            paso
          </span>
        </div>
      </section>

      {/* SECTION 3 - PAIN POINTS */}
      <section className="bg-gray-50 py-16 px-4 border-y border-gray-200" data-id="element-34">
        <div className="max-w-4xl mx-auto" data-id="element-35">
          <h3 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-36">
            Déjame hacerte una pregunta honesta…
          </h3>

          <div className="space-y-6 text-lg md:text-xl font-medium bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-37">
            <p className="flex items-start gap-3" data-id="element-38">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-39" />{' '}
              ¿Revisás el celular apenas despertás?
            </p>
            <p className="flex items-start gap-3" data-id="element-40">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-41" />{' '}
              ¿Saltás de una app a otra sin darte cuenta?
            </p>
            <p className="flex items-start gap-3" data-id="element-42">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-43" />{' '}
              ¿Te cuesta concentrarte más de unos minutos?
            </p>
            <p className="flex items-start gap-3" data-id="element-44">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-45" />{' '}
              ¿Sentís ansiedad cuando no tenés el celular cerca?
            </p>
            <p className="flex items-start gap-3" data-id="element-46">
              <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-1" data-id="element-47" />{' '}
              ¿Terminás el día cansado pero sin haber hecho lo importante?
            </p>
          </div>

          <div className="mt-12 text-center text-xl md:text-2xl font-bold space-y-2" data-id="element-48">
            <p data-id="element-49">
              Si respondiste sí a varias de estas preguntas, no es casualidad.
            </p>
            <p data-id="element-50">Tu cerebro está siendo entrenado por los algoritmos.</p>
            <p className="text-purple-600 text-3xl mt-4" data-id="element-51">
              Es dopamina digital.
            </p>
            <p className="text-gray-600 mt-2" data-id="element-52">
              Y tu cerebro necesita un reset.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4 - THE PROBLEM */}
      <section className="bg-black text-white py-20 px-4" data-id="element-53">
        <div className="max-w-4xl mx-auto text-center" data-id="element-54">
          <h2 className="text-4xl md:text-5xl font-black mb-12 text-purple-500" data-id="element-55">
            El problema que casi nadie reconoce
          </h2>

          <p className="text-xl md:text-2xl mb-4" data-id="element-56">
            Las aplicaciones modernas están diseñadas para capturar tu atención
            el mayor tiempo posible.
          </p>
          <p className="text-lg md:text-xl mb-8 text-gray-300" data-id="element-57">
            Cada notificación, cada like y cada video corto activa tu sistema de
            recompensa cerebral. Ese mismo sistema está relacionado con las
            adicciones.
          </p>

          <p className="text-xl md:text-2xl mb-6 text-left max-w-2xl mx-auto" data-id="element-58">
            Por eso muchas personas sienten:
          </p>

          <ul className="text-lg md:text-xl space-y-4 text-left max-w-2xl mx-auto bg-gray-900 p-8 rounded-xl border border-gray-800" data-id="element-59">
            <li className="flex items-center gap-3" data-id="element-60">
              <div className="w-2 h-2 bg-purple-500 rounded-full" data-id="element-61"></div>{' '}
              Ansiedad constante
            </li>
            <li className="flex items-center gap-3" data-id="element-62">
              <div className="w-2 h-2 bg-purple-500 rounded-full" data-id="element-63"></div>{' '}
              Dificultad para concentrarse
            </li>
            <li className="flex items-center gap-3" data-id="element-64">
              <div className="w-2 h-2 bg-purple-500 rounded-full" data-id="element-65"></div> Falta
              de motivación
            </li>
            <li className="flex items-center gap-3" data-id="element-66">
              <div className="w-2 h-2 bg-purple-500 rounded-full" data-id="element-67"></div>{' '}
              Cansancio mental
            </li>
            <li className="flex items-center gap-3" data-id="element-68">
              <div className="w-2 h-2 bg-purple-500 rounded-full" data-id="element-69"></div>{' '}
              Problemas para dormir
            </li>
            <li className="flex items-center gap-3" data-id="element-70">
              <div className="w-2 h-2 bg-purple-500 rounded-full" data-id="element-71"></div>{' '}
              Sensación de perder el control del tiempo
            </li>
          </ul>

          <div className="mt-12 text-2xl font-bold" data-id="element-72">
            <p className="mb-4" data-id="element-73">
              Y lo peor es que muchas personas creen que simplemente les falta
              fuerza de voluntad.
            </p>
            <p className="text-gray-400" data-id="element-74">Pero no.</p>
            <blockquote className="text-3xl md:text-4xl text-purple-400 italic mt-6 font-black" data-id="element-75">
              "Tu cerebro está sobreestimulado."
            </blockquote>
            <p className="text-gray-400 mt-6" data-id="element-76">Y necesita un reset.</p>
          </div>
        </div>
      </section>

      {/* SECTION 5 - THE SOLUTION */}
      <section className="py-20 px-4 bg-white" data-id="element-77">
        <div className="max-w-5xl mx-auto text-center" data-id="element-78">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-6 py-2 rounded-full text-xl mb-6" data-id="element-79">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-5xl font-black mb-4 text-center" data-id="element-80">
            <span className="block" data-id="element-81">🧠 MEGA PACK</span>
            <span className="block text-purple-500" data-id="element-82">RESET DE DOPAMINA</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-600 mb-4" data-id="element-83">
            Un sistema estructurado diseñado para ayudarte a reprogramar tu
            relación con el celular en solo 14 días.
          </p>
          <p className="text-lg md:text-xl text-gray-500 mb-12 italic" data-id="element-84">
            No es teoría. Es un proceso práctico paso a paso.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 mb-12" data-id="element-85">
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-86">
              <span className="text-4xl block mb-2" data-id="element-87">📂</span>
              <p className="font-bold" data-id="element-88">Accedés al Mega Pack</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-89" />
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-90">
              <span className="text-4xl block mb-2" data-id="element-91">📘</span>
              <p className="font-bold" data-id="element-92">Implementás el contenido por Tomos</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-93" />
            <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 w-full md:w-1/4" data-id="element-94">
              <span className="text-4xl block mb-2" data-id="element-95">⚙</span>
              <p className="font-bold" data-id="element-96">Aplicás el proceso durante 14 días</p>
            </div>
            <ChevronRight className="hidden md:block text-gray-400 w-8 h-8" data-id="element-97" />
            <div className="bg-purple-50 p-6 rounded-xl border border-purple-200 w-full md:w-1/4 shadow-md" data-id="element-98">
              <span className="text-4xl block mb-2" data-id="element-99">🧠</span>
              <p className="font-bold text-purple-800" data-id="element-100">
                Recuperás control mental y concentración
              </p>
            </div>
          </div>

          <div className="text-2xl font-bold text-gray-800 space-y-2" data-id="element-101">
            <p data-id="element-102">
              Sin fuerza de voluntad extrema. Sin eliminar la tecnología de tu
              vida. Sin métodos complicados.
            </p>
            <p className="text-3xl text-purple-600 mt-4" data-id="element-103">
              Solo un sistema claro para recuperar tu atención.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 6 - WHAT'S INCLUDED */}
      <section className="py-16 px-4 bg-gray-50 border-t border-gray-200" data-id="element-104">
        <div className="max-w-6xl mx-auto" data-id="element-105">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-6" data-id="element-106">
            📘 ¿Qué incluye exactamente el
            <span className="block text-4xl md:text-5xl mt-2" data-id="element-107">
              🧠 MEGA PACK
            </span>
            <span className="block text-4xl md:text-5xl text-purple-500" data-id="element-108">
              RESET DE DOPAMINA?
            </span>
          </h2>
          <p className="text-xl text-center text-gray-600 mb-12 font-medium" data-id="element-109">
            Un sistema dividido en 6 Tomos estratégicos + 3 Bonos especiales,
            diseñados para aplicación real.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-110">
            {/* Tomo 1 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-111">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-112">
                📘 TOMO 1
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-113">
                El cerebro secuestrado
              </h4>
              <div className="space-y-3 text-gray-700 font-medium" data-id="element-114">
                <p data-id="element-115">
                  Descubre cómo las redes sociales, apps y notificaciones
                  manipulan tu cerebro.
                </p>
                <p data-id="element-116">Entenderás por qué el celular es tan difícil de dejar.</p>
                <p data-id="element-117">
                  Cuando comprendas esto, dejarás de culparte y empezarás a
                  recuperar el control.
                </p>
              </div>
            </div>

            {/* Tomo 2 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-118">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-119">
                📘 TOMO 2
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-120">
                El diagnóstico digital
              </h4>
              <div className="space-y-3 text-gray-700 font-medium" data-id="element-121">
                <p data-id="element-122">
                  Aquí descubrirás cuánto tiempo y energía está consumiendo
                  realmente tu celular.
                </p>
                <p data-id="element-123">
                  Identificarás los patrones invisibles que están drenando tu
                  atención.
                </p>
                <p data-id="element-124">
                  Este diagnóstico cambia completamente la perspectiva sobre el
                  uso digital.
                </p>
              </div>
            </div>

            {/* Tomo 3 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-125">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-126">
                📘 TOMO 3
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-127">
                Detox digital
              </h4>
              <div className="space-y-3 text-gray-700 font-medium" data-id="element-128">
                <p data-id="element-129">El corazón del método.</p>
                <p data-id="element-130">
                  Aplicarás técnicas concretas para reducir el estímulo
                  constante y desintoxicar tu mente.
                </p>
                <p data-id="element-131">
                  Es el punto donde muchas personas experimentan su primer gran
                  cambio mental.
                </p>
              </div>
            </div>

            {/* Tomo 4 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-132">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-133">
                📘 TOMO 4
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-134">
                Reprograma tu cerebro
              </h4>
              <div className="space-y-3 text-gray-700 font-medium" data-id="element-135">
                <p data-id="element-136">
                  Aprenderás a reemplazar los hábitos digitales por hábitos que
                  aumentan enfoque, energía y claridad mental.
                </p>
                <p data-id="element-137">
                  Tu mente empieza a recuperar su capacidad natural de atención
                  profunda.
                </p>
              </div>
            </div>

            {/* Tomo 5 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-138">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-139">
                📘 TOMO 5
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-140">
                Recupera tu enfoque
              </h4>
              <div className="space-y-3 text-gray-700 font-medium" data-id="element-141">
                <p data-id="element-142">
                  Técnicas prácticas para volver a concentrarte durante períodos
                  largos.
                </p>
                <p data-id="element-143">
                  Algo que millones de personas han perdido por el consumo
                  constante de estímulos digitales.
                </p>
              </div>
            </div>

            {/* Tomo 6 */}
            <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-purple-500" data-id="element-144">
              <h3 className="text-2xl font-bold mb-2 text-gray-900" data-id="element-145">
                📘 TOMO 6
              </h3>
              <h4 className="text-xl font-bold text-purple-600 mb-4" data-id="element-146">
                Vida después del Reset
              </h4>
              <div className="space-y-3 text-gray-700 font-medium" data-id="element-147">
                <p data-id="element-148">Cómo mantener tu libertad digital a largo plazo.</p>
                <p data-id="element-149">
                  Convertirás este proceso en un estilo de vida donde la
                  tecnología trabaja para vos y no al revés.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 - BEFORE VS AFTER */}
      <section className="py-20 px-4 bg-white" data-id="element-150">
        <div className="max-w-5xl mx-auto" data-id="element-151">
          <h2 className="text-4xl md:text-5xl font-black text-center mb-12" data-id="element-152">
            Antes vs Después
          </h2>

          <div className="flex flex-col md:flex-row gap-8 mb-12" data-id="element-153">
            <div className="flex-1 bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-154">
              <h3 className="text-2xl font-bold text-red-800 mb-6 text-center border-b border-red-200 pb-4" data-id="element-155">
                Antes del Reset Dopamina
              </h3>
              <ul className="space-y-4 text-lg font-medium text-red-900" data-id="element-156">
                <li className="flex items-start gap-3" data-id="element-157">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-158" />{' '}
                  Vivís revisando el celular constantemente
                </li>
                <li className="flex items-start gap-3" data-id="element-159">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-160" />{' '}
                  Te cuesta concentrarte
                </li>
                <li className="flex items-start gap-3" data-id="element-161">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-162" />{' '}
                  Saltás de una app a otra
                </li>
                <li className="flex items-start gap-3" data-id="element-163">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-164" />{' '}
                  Sentís ansiedad digital
                </li>
                <li className="flex items-start gap-3" data-id="element-165">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-166" />{' '}
                  Perdés horas sin darte cuenta
                </li>
                <li className="flex items-start gap-3" data-id="element-167">
                  <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-168" />{' '}
                  Terminás el día cansado mentalmente
                </li>
              </ul>
            </div>

            <div className="flex-1 bg-green-50 p-8 rounded-2xl border border-green-200 shadow-xl transform md:-translate-y-4" data-id="element-169">
              <h3 className="text-2xl font-bold text-green-800 mb-6 text-center border-b border-green-200 pb-4" data-id="element-170">
                Después de completar el Reset
              </h3>
              <ul className="space-y-4 text-lg font-medium text-green-900" data-id="element-171">
                <li className="flex items-start gap-3" data-id="element-172">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-173" />{' '}
                  Tenés control sobre tu uso del celular
                </li>
                <li className="flex items-start gap-3" data-id="element-174">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-175" />{' '}
                  Recuperás tu concentración
                </li>
                <li className="flex items-start gap-3" data-id="element-176">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-177" />{' '}
                  Tu mente se siente más clara
                </li>
                <li className="flex items-start gap-3" data-id="element-178">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-179" />{' '}
                  Dormís mejor
                </li>
                <li className="flex items-start gap-3" data-id="element-180">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-181" />{' '}
                  Tenés más energía
                </li>
                <li className="flex items-start gap-3" data-id="element-182">
                  <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-183" />{' '}
                  Recuperás tiempo real de tu día
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center mb-12" data-id="element-184">
            <p className="text-2xl font-bold text-gray-600" data-id="element-185">
              No se trata de usar menos tecnología.
            </p>
            <p className="text-3xl font-black text-purple-600 mt-2" data-id="element-186">
              Se trata de volver a tener control sobre tu mente.
            </p>
          </div>

          <CTAButton text="🚀 QUIERO EMPEZAR MI RESET AHORA" data-id="element-187" />
        </div>
      </section>

      {/* SECTION 8 - BONUSES */}
      <section className="py-20 px-4 bg-gray-900 text-white" data-id="element-188">
        <div className="max-w-6xl mx-auto" data-id="element-189">
          <div className="text-center mb-12" data-id="element-190">
            <h2 className="text-4xl md:text-5xl font-black mb-4 text-purple-400" data-id="element-191">
              🎁 Regalos especiales
            </h2>

            <div className="inline-block bg-red-600 text-white font-black px-6 py-2 rounded-lg text-xl animate-pulse" data-id="element-192">
              Estos bonos están incluidos solo por tiempo limitado.
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-193">
            {/* Bono 1 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-194">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-195">
                <img src="https://cdn.magicpatterns.com/uploads/6D8z4VrGrg1DdmLYyJ6BS3/ChatGPT_Image_5_mar_2026,_15_05_04_(1).png" alt="Bono 1 - Planificador Reset Dopamina" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-196" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-197">
                <h4 className="text-xl font-black text-purple-600 mb-4" data-id="element-198">
                  🎁 BONO 1 – Planificador Reset Dopamina
                </h4>
                <ul className="space-y-3 font-medium flex-1" data-id="element-199">
                  <li className="flex items-start gap-2" data-id="element-200">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-201" />{' '}
                    Un sistema de seguimiento para completar el proceso de 14
                    días paso a paso.
                  </li>
                  <li className="flex items-start gap-2" data-id="element-202">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-203" />{' '}
                    Te ayudará a mantener compromiso y medir tu progreso.
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono 2 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-204">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-205">
                <img src="https://cdn.magicpatterns.com/uploads/fVBjCjTeDe4xEgfwuyBKRb/ChatGPT_Image_5_mar_2026,_15_05_12.png" alt="Bono 2 - Checklist Reset Dopamina" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-206" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-207">
                <h4 className="text-xl font-black text-purple-600 mb-4" data-id="element-208">
                  🎁 BONO 2 – Checklist Reset Dopamina
                </h4>
                <ul className="space-y-3 font-medium flex-1" data-id="element-209">
                  <li className="flex items-start gap-2" data-id="element-210">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-211" />{' '}
                    Lista práctica de acciones para aplicar el método sin
                    perderte en el proceso.
                  </li>
                  <li className="flex items-start gap-2" data-id="element-212">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-213" />{' '}
                    Perfecto para quienes quieren resultados rápidos.
                  </li>
                </ul>
              </div>
            </div>

            {/* Bono 3 */}
            <div className="bg-white text-gray-900 rounded-2xl overflow-hidden shadow-2xl flex flex-col" data-id="element-214">
              <a href="#compra" className="block overflow-hidden bg-gray-100" data-id="element-215">
                <img src="https://cdn.magicpatterns.com/uploads/nqNB6eQUWBvhbq84KsY1Qa/ChatGPT_Image_5_mar_2026,_15_06_51.png" alt="Bono 3 - Rutina Matutina Anti-Celular" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-500" data-id="element-216" />
              </a>
              <div className="p-6 flex-1 flex flex-col" data-id="element-217">
                <h4 className="text-xl font-black text-purple-600 mb-4" data-id="element-218">
                  🎁 BONO 3 – Rutina Matutina Anti-Celular
                </h4>
                <ul className="space-y-3 font-medium flex-1" data-id="element-219">
                  <li className="flex items-start gap-2" data-id="element-220">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-221" />{' '}
                    Un protocolo simple para comenzar el día sin caer en la
                    trampa del celular.
                  </li>
                  <li className="flex items-start gap-2" data-id="element-222">
                    <CheckCircle2 className="text-green-500 w-5 h-5 flex-shrink-0" data-id="element-223" />{' '}
                    Diseñado para aumentar energía, claridad mental y enfoque.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 9 - TESTIMONIALS */}
      <section className="py-20 px-4 bg-gray-50" data-id="element-224">
        <div className="max-w-6xl mx-auto" data-id="element-225">
          <h2 className="text-3xl md:text-4xl font-black text-center mb-12" data-id="element-226">
            Qué reportan las personas que hacen el reset
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-227">
            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-228">
              <div className="flex items-center gap-4 mb-4" data-id="element-229">
                <img src="https://i.pravatar.cc/80?img=32" alt="Valentina Ruiz" className="w-14 h-14 rounded-full" data-id="element-230" />
                <div data-id="element-231">
                  <h4 className="font-bold text-gray-900" data-id="element-232">Valentina Ruiz</h4>
                  <p className="text-sm text-gray-500" data-id="element-233">
                    Estudiante - Buenos Aires
                  </p>
                </div>
              </div>
              <div className="flex text-purple-400 mb-2" data-id="element-234">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-235">
                "Antes no podía estudiar ni 20 minutos sin agarrar el celular.
                Después del reset, puedo concentrarme horas. Mi rendimiento
                académico mejoró muchísimo."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-236">
              <div className="flex items-center gap-4 mb-4" data-id="element-237">
                <img src="https://i.pravatar.cc/80?img=53" alt="Martín Acosta" className="w-14 h-14 rounded-full" data-id="element-238" />
                <div data-id="element-239">
                  <h4 className="font-bold text-gray-900" data-id="element-240">Martín Acosta</h4>
                  <p className="text-sm text-gray-500" data-id="element-241">Emprendedor - Córdoba</p>
                </div>
              </div>
              <div className="flex text-purple-400 mb-2" data-id="element-242">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-243">
                "Recuperé al menos 3 horas al día que perdía en redes. Ahora las
                uso para mi negocio. La productividad se disparó."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-244">
              <div className="flex items-center gap-4 mb-4" data-id="element-245">
                <img src="https://i.pravatar.cc/80?img=44" alt="Camila Herrera" className="w-14 h-14 rounded-full" data-id="element-246" />
                <div data-id="element-247">
                  <h4 className="font-bold text-gray-900" data-id="element-248">Camila Herrera</h4>
                  <p className="text-sm text-gray-500" data-id="element-249">Psicóloga - Rosario</p>
                </div>
              </div>
              <div className="flex text-purple-400 mb-2" data-id="element-250">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-251">
                "Mi ansiedad bajó notablemente. Duermo mejor, me despierto con
                más energía. No sabía cuánto me afectaba el celular hasta que
                hice el detox."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-252">
              <div className="flex items-center gap-4 mb-4" data-id="element-253">
                <img src="https://i.pravatar.cc/80?img=59" alt="Federico López" className="w-14 h-14 rounded-full" data-id="element-254" />
                <div data-id="element-255">
                  <h4 className="font-bold text-gray-900" data-id="element-256">Federico López</h4>
                  <p className="text-sm text-gray-500" data-id="element-257">Programador - Mendoza</p>
                </div>
              </div>
              <div className="flex text-purple-400 mb-2" data-id="element-258">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-259">
                "Trabajo frente a una pantalla todo el día y el celular era mi
                peor distracción. El método me devolvió el enfoque profundo que
                necesitaba."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-260">
              <div className="flex items-center gap-4 mb-4" data-id="element-261">
                <img src="https://i.pravatar.cc/80?img=26" alt="Lucía Morales" className="w-14 h-14 rounded-full" data-id="element-262" />
                <div data-id="element-263">
                  <h4 className="font-bold text-gray-900" data-id="element-264">Lucía Morales</h4>
                  <p className="text-sm text-gray-500" data-id="element-265">Docente - La Plata</p>
                </div>
              </div>
              <div className="flex text-purple-400 mb-2" data-id="element-266">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-267">
                "Lo mejor fue la rutina matutina. Empezar el día sin el celular
                me cambió la energía por completo. Ahora estoy presente con mis
                alumnos."
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100" data-id="element-268">
              <div className="flex items-center gap-4 mb-4" data-id="element-269">
                <img src="https://i.pravatar.cc/80?img=60" alt="Santiago Díaz" className="w-14 h-14 rounded-full" data-id="element-270" />
                <div data-id="element-271">
                  <h4 className="font-bold text-gray-900" data-id="element-272">Santiago Díaz</h4>
                  <p className="text-sm text-gray-500" data-id="element-273">Diseñador - Tucumán</p>
                </div>
              </div>
              <div className="flex text-purple-400 mb-2" data-id="element-274">★★★★★</div>
              <p className="text-gray-700 italic" data-id="element-275">
                "En 14 días pasé de usar el celular 7 horas diarias a menos de
                2. Recuperé mi mente y mi tiempo. Vale cada peso."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 10 - PURCHASE SECTION */}
      <section id="compra" className="py-20 px-4 bg-white border-t border-gray-200" data-id="element-276">
        <div className="max-w-4xl mx-auto bg-purple-50 rounded-3xl p-8 md:p-12 border-4 border-purple-400 shadow-2xl relative" data-id="element-277">
          <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-8 py-3 rounded-full font-black md:text-2xl shadow-lg whitespace-nowrap text-[18px] animate-pulse" data-id="element-278">
            ⏰ Acceso disponible por tiempo limitado
          </div>

          <div className="mt-10 mb-10 text-center" data-id="element-279">
            <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-8" data-id="element-280">
              IMAGINA ESTO...
            </h3>

            <ul className="space-y-4 text-lg md:text-xl font-bold text-gray-800 max-w-lg mx-auto text-left mb-10" data-id="element-281">
              <li className="flex items-center gap-3" data-id="element-282">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-283" />{' '}
                Despertarte sin revisar el celular automáticamente.
              </li>
              <li className="flex items-center gap-3" data-id="element-284">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-285" />{' '}
                Poder concentrarte durante horas en lo importante.
              </li>
              <li className="flex items-center gap-3" data-id="element-286">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-287" />{' '}
                Sentir tu mente tranquila.
              </li>
              <li className="flex items-center gap-3" data-id="element-288">
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0" data-id="element-289" />{' '}
                Disfrutar actividades reales sin distracciones constantes.
              </li>
            </ul>

            <div className="mb-10" data-id="element-290">
              <p className="text-xl md:text-2xl text-gray-500 font-bold line-through mb-2" data-id="element-291">
                Precio regular: $49.990
              </p>
              <p className="text-2xl md:text-3xl font-black text-gray-900 mb-3" data-id="element-292">
                HOY SOLO:
              </p>
              <div className="inline-block bg-white rounded-2xl px-10 py-5 border-3 border-purple-500 shadow-xl" data-id="element-293">
                <p className="text-6xl md:text-7xl lg:text-8xl font-black text-purple-600" data-id="element-294">
                  $19.990
                </p>
              </div>
            </div>
          </div>

          <CTAButton text="👉 COMENZAR MI RESET AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-295" />

          <div className="text-center mt-4 mb-10 text-sm text-gray-500 font-medium flex items-center justify-center gap-1" data-id="element-296">
            <Lock className="w-4 h-4" data-id="element-297" /> Pago 100% Seguro
          </div>

          <div className="bg-white p-6 rounded-xl border border-gray-200 text-center" data-id="element-298">
            <div className="flex justify-center mb-4" data-id="element-299">
              <ShieldCheck className="w-16 h-16 text-green-500" data-id="element-300" />
            </div>
            <h4 className="text-2xl font-black mb-2 flex items-center justify-center gap-2" data-id="element-301">
              <Lock className="w-6 h-6" data-id="element-302" /> Garantía sin riesgo
            </h4>
            <p className="text-gray-700 font-medium mb-4" data-id="element-303">
              Implementalo durante los primeros días.
            </p>
            <p className="text-gray-700 font-medium mb-4" data-id="element-304">
              Si no sentís mayor claridad y estructura, podés solicitar
              reembolso.
            </p>
            <p className="text-gray-900 font-bold" data-id="element-305">
              Porque el problema no es tu capacidad. Es la dopamina digital.
            </p>
            <p className="text-purple-600 font-bold mt-2" data-id="element-306">
              Y eso es exactamente lo que resuelve este Mega Pack.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 11 - WHO IS THIS FOR */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-307">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-308">
          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-green-500" data-id="element-309">
            <h3 className="text-2xl font-black mb-6 text-gray-900" data-id="element-310">
              💡 ¿Para quién es?
            </h3>
            <ul className="space-y-4 font-medium text-lg" data-id="element-311">
              <li className="flex items-start gap-3" data-id="element-312">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-313" />{' '}
                Personas que sienten que usan demasiado el celular
              </li>
              <li className="flex items-start gap-3" data-id="element-314">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-315" />{' '}
                Estudiantes que quieren recuperar concentración
              </li>
              <li className="flex items-start gap-3" data-id="element-316">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-317" />{' '}
                Profesionales que quieren más productividad
              </li>
              <li className="flex items-start gap-3" data-id="element-318">
                <CheckCircle2 className="text-green-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-319" />{' '}
                Personas que sienten ansiedad digital
              </li>
            </ul>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-red-500" data-id="element-320">
            <h3 className="text-2xl font-black mb-6 text-gray-900" data-id="element-321">
              🚫 ¿Para quién NO es?
            </h3>
            <ul className="space-y-4 font-medium text-lg" data-id="element-322">
              <li className="flex items-start gap-3" data-id="element-323">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-324" />{' '}
                Para quien no quiere cambiar su relación con la tecnología.
              </li>
              <li className="flex items-start gap-3" data-id="element-325">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-326" />{' '}
                Para quien busca soluciones mágicas sin aplicar el método.
              </li>
              <li className="flex items-start gap-3" data-id="element-327">
                <XCircle className="text-red-500 w-6 h-6 flex-shrink-0 mt-0.5" data-id="element-328" />{' '}
                Para quien no está dispuesto a hacer pequeños cambios durante 14
                días.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* SECTION 12 - WHAT YOU'RE REALLY BUYING */}
      <section className="py-20 px-4 bg-black text-white text-center" data-id="element-329">
        <div className="max-w-4xl mx-auto" data-id="element-330">
          <h2 className="text-4xl md:text-5xl font-black mb-8 text-purple-500" data-id="element-331">
            📈 Lo que realmente estás comprando
          </h2>
          <p className="text-2xl font-bold mb-10 text-gray-300" data-id="element-332">
            No son solo 6 ebooks.
          </p>
          <p className="text-xl mb-8" data-id="element-333">Estás comprando:</p>

          <ul className="text-2xl md:text-3xl font-black space-y-6 text-purple-400" data-id="element-334">
            <li data-id="element-335">✔ un sistema para recuperar tu atención</li>
            <li data-id="element-336">✔ un método para reducir ansiedad digital</li>
            <li data-id="element-337">✔ una estructura para mejorar tu concentración</li>
            <li data-id="element-338">✔ un proceso para recuperar tiempo y claridad mental</li>
          </ul>
        </div>
      </section>

      {/* SECTION 13 - FINAL CTA */}
      <section className="py-24 px-4 bg-white text-center" data-id="element-339">
        <div className="max-w-4xl mx-auto" data-id="element-340">
          <h2 className="text-5xl md:text-6xl font-black mb-6 text-center" data-id="element-341">
            <span className="block" data-id="element-342">🧠 MEGA PACK</span>
            <span className="block text-purple-500" data-id="element-343">RESET DE DOPAMINA</span>
          </h2>
          <p className="text-2xl md:text-3xl font-bold text-gray-600 mb-12" data-id="element-344">
            El sistema práctico para romper la adicción digital, recuperar tu
            enfoque y volver a tener control sobre tu mente.
          </p>

          <div className="text-3xl md:text-4xl font-black text-purple-600 space-y-4 mb-12" data-id="element-345">
            <p data-id="element-346">
              👉 Es momento de dejar de entregar tu atención a los algoritmos.
            </p>
            <p data-id="element-347">👉 Es momento de recuperar tu mente.</p>
          </div>

          <CTAButton text="🚀 SÍ, QUIERO EMPEZAR MI RESET AHORA" href={PURCHASE_LINK} isExternal={true} className="text-2xl md:text-3xl py-6" data-id="element-348" />
          <p className="mt-6 text-xl font-bold text-gray-700" data-id="element-349">
            Rompe la adicción al celular. Recupera tu enfoque. Recupera tu vida.
          </p>
        </div>
      </section>
    </div>;
}